import React from 'react'
import styles from './connect.module.css'
import axios from 'axios'
import Validator from 'validatorjs'

export default class ConnectModal extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      formInput: {},
      errorMessage: null,
      formStatus: 'idle',
    }
  }

  handleFieldChanged(name, value) {
    this.setState({
      formInput: {
        ...this.state.formInput,
        [name]: value
      }
    })
  }

  handleSubmitClicked() {
    const { formInput } = this.state

    this.setState({ errorMessage: null })

    //TODO: validate
    let validation = new Validator(formInput, {
      name: 'required',
      email: 'required|email',
      message: 'required'
    });

    if(validation.fails()) {
      this.setState({ formStatus: 'failed', errorMessage: 'Please enter all the required fields.' })
      return
    }

    this.setState({ formStatus: 'loading' })
    axios.post('/.netlify/functions/submit-contact', formInput)
      .then(res => {
        this.setState({ formStatus: 'success' })
      })
      .catch(err => {
        //TODO: show error
        this.setState({ 
          formStatus: 'failed', 
          errorMessage: 'Contact submission failed for an unknown reason'
        })
      })
  }

  handleCloseClicked() {
    const { onClose } = this.props
    if(onClose)
      onClose()
  }

  render() {
    const { errorMessage, formStatus } = this.state
    const { message } = this.props
    return (
      <div className={styles.connectModalOverlay}>
        <div className={styles.connectModal}>
          <h2>Let's Connect</h2>
          
          {message && 
            <p>
              {message}
            </p>
          }

          <div className={styles.contactForm}>
            <div className={styles.formField}>
              <label>Name*</label><br />
              <input type="text" className={styles.textInput}
                onChange={e => {
                  this.handleFieldChanged('name', e.target.value)
                }} />
            </div>

            <div className={styles.formField}>
              <label>Email*</label><br />
              <input type="text" className={styles.textInput}
                onChange={e => {
                  this.handleFieldChanged('email', e.target.value)
                }} />
            </div>

            <div className={styles.formField}>
              <label>Message*</label><br />
              <textarea className={styles.textInput} rows="5"
                onChange={e => {
                  this.handleFieldChanged('message', e.target.value)
                }} >
              </textarea>
            </div>

            {formStatus === 'failed' &&
              <div className={styles.formField}>
                {errorMessage}
              </div>
            }

            {formStatus === 'success' &&
              <div className={styles.formField}>
                Thank You for submitting your contact.
              </div>
            }

            {formStatus === 'loading' &&
              <div className={styles.formField}>
                Loading...
              </div>
            }

            <div className={styles.formFooter}>
              <button onClick={this.handleSubmitClicked.bind(this)}
                className={styles.button}>
                Submit
              </button>
              <button onClick={this.handleCloseClicked.bind(this)}
                className={styles.button}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

}